"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRequestEmailChangeResponseDto = instanceOfRequestEmailChangeResponseDto;
exports.RequestEmailChangeResponseDtoFromJSON = RequestEmailChangeResponseDtoFromJSON;
exports.RequestEmailChangeResponseDtoFromJSONTyped = RequestEmailChangeResponseDtoFromJSONTyped;
exports.RequestEmailChangeResponseDtoToJSON = RequestEmailChangeResponseDtoToJSON;
exports.RequestEmailChangeResponseDtoToJSONTyped = RequestEmailChangeResponseDtoToJSONTyped;
/**
 * Check if a given object implements the RequestEmailChangeResponseDto interface.
 */
function instanceOfRequestEmailChangeResponseDto(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined)
        return false;
    return true;
}
function RequestEmailChangeResponseDtoFromJSON(json) {
    return RequestEmailChangeResponseDtoFromJSONTyped(json, false);
}
function RequestEmailChangeResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
        'statusCode': json['statusCode'],
    };
}
function RequestEmailChangeResponseDtoToJSON(json) {
    return RequestEmailChangeResponseDtoToJSONTyped(json, false);
}
function RequestEmailChangeResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'statusCode': value['statusCode'],
    };
}
